import dayjs from "dayjs";
import { from, Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { DocReference, Query } from "../../../types/firebase.types";
import { GenericObject } from "../../../types/generic.types";
import { courtsSlotsSubCollRef } from "../../../utils/referencies";
import { generateTimestamp } from "../../../utils/timestamp";
import { CellManageMode } from "../types";

export const getCourt = (courtRef: DocReference): Observable<GenericObject | null> => {
  return from(courtRef.get()).pipe(
    map((snapshot) => ({
      ...snapshot.data(),
      id: snapshot.id,
    })),
    catchError((ex: any) => {
      console.log(ex.message);
      return of(null);
    })
  );
};

/**
 * Query to get slots in a specific selected range
 * */
export const getSlotsInRange = (courtId: string, startDate: Date, endDate: Date) => {
  return courtsSlotsSubCollRef(courtId)
    .where("startTime", ">=", generateTimestamp(startDate))
    .where("startTime", "<", generateTimestamp(dayjs(endDate).add(1, "day").toDate()));
};

export const checkReservedSlots = async (query: Query, mode: CellManageMode): Promise<boolean> => {
  if (mode === CellManageMode.overwrite) {
    try {
      const snapshot = await query.where("reserved", "==", true).limit(1).get();
      if (!snapshot.empty) {
        return true;
      }
    } catch (ex: any) {
      console.log(ex.message);
      return false;
    }
  }
  return false;
};
